import { PublicClientApplication } from '@azure/msal-browser';
import logger from '../utils/logger';


// Validate that required environment variables are set
if (!process.env.REACT_APP_AZURE_CLIENT_ID) {
  logger.warn('Missing REACT_APP_AZURE_CLIENT_ID environment variable. Azure authentication may not work correctly.');
}
if (!process.env.REACT_APP_AZURE_TENANT_ID) {
  logger.warn('Missing REACT_APP_AZURE_TENANT_ID environment variable. Azure authentication may not work correctly.');
}

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage', // or 'localStorage' if you prefer
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
